import { render } from "./change-password-modal.vue?vue&type=template&id=0b6156ff&scoped=true"
import script from "./change-password-modal.vue?vue&type=script&lang=js"
export * from "./change-password-modal.vue?vue&type=script&lang=js"

import "./change-password-modal.vue?vue&type=style&index=0&id=0b6156ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6156ff"]])

export default __exports__